import { Outlet } from "react-router-dom";

const OverallLayout = () => {
  return (
    <><Outlet /></>
  )
}
export default OverallLayout;